import React,{useState} from 'react'
import {MdKeyboardArrowRight} from 'react-icons/md';
import {MdKeyboardArrowDown} from 'react-icons/md';
const Dropdown = ({name,content}) => {
  const [drop,setDrop]=useState('hidden');
  const DropAction=()=>{
    if(drop==='hidden'){
      setDrop('block')
    }
  else{
    setDrop('hidden');
  }
  }
  return (
    <div>
    <button onClick={DropAction} className=' w-full flex items-center justify-between border border-transparent border-b-gray-300 text-sm font-medium  py-1 text-left hover:bg-white/90'>{name} <span className='block text-right pr-2'><MdKeyboardArrowRight className={`${drop=='hidden'?'block':'hidden'}`} /> <MdKeyboardArrowDown className={`${drop}`}/> </span> </button>
    <div className={`${drop}`}>
      <ul className='text-sm text-black font-normal'>
       
       {
         content.map((curElem,index)=>{
           return (
            <li key={index} className='hover:bg-rose-50'><a href="/" className='w-full block  p-0.5'>{curElem}</a></li>
           )
         })
       }

        
       
      </ul>
    </div>
    </div>
  )
}

export default Dropdown